import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
// redux
import { connect } from 'react-redux';
import { setPageNotFound } from '../../redux/actions/app/appActions';
import { TechnicalError } from '../../components/technical-error/TechnicalError';

export class NotFound extends PureComponent {

  static propTypes = {
    setPageNotFound: PropTypes.func,
  };

  static defaultProps = {
    setPageNotFound: window.defaultFunc,
  };

  componentDidMount() {
    const { setPageNotFound } = this.props;
    setPageNotFound();
  }

  render() {
    return (
      <TechnicalError pageNotFoundTechnicalError />
    );
  }
}

export function mapDispatchToProps() {
  return { setPageNotFound };
}

export default connect(null, mapDispatchToProps())(NotFound);
